/** @jsxImportSource @emotion/react */

import Button from "../../../../components/Button";
import CustomLink from "../../../../components/CustomLink";
import { IconNames } from "../../../../components/Icons/styles/iconNames";
import { useAuth } from "../../../../hooks/useAuth";
import { ToSimulationLocation } from "../../../../Locations";

const styles = {
  buttons: {
    "& > button": {
      marginBottom: 12,
    },
  },
};

const SidebarTopButtons = () => {
  const { shareProviderLink } = useAuth();

  return (
    <div css={styles.buttons}>
      <CustomLink to={ToSimulationLocation("new", "simulacao_completo")}>
        <Button text="Nova Cotação" iconName={IconNames.Add} align="left" />
      </CustomLink>
      <Button
        text="Link"
        iconName={IconNames.Share}
        align="left"
        onClick={shareProviderLink}
      />
    </div>
  );
};

export default SidebarTopButtons;
